import { useConfig } from "../../context/config-context";

const ContractLabel = ({ type }) => {
  const siteConfig = useConfig();

  let config = null;
  if (type === "EXPERTIS") {
    config = {
      imgSrc: siteConfig.medias.contract.EXPERTIS.path,
      bgColor: siteConfig.utils.contractTypes.EXPERTIS.color,
    };
  } else if (type === "INTENSIS") {
    config = {
      imgSrc: siteConfig.medias.contract.INTENSIS.path,
      bgColor: siteConfig.utils.contractTypes.INTENSIS.color,
    };
  } else if (type === "TELESIS") {
    config = {
      imgSrc: siteConfig.medias.contract.TELESIS.path,
      bgColor: siteConfig.utils.contractTypes.TELESIS.color,
    };
  }

  if (type) {
    return (
      <div className="flex gap-2">
        {config && type !== "EXPERTIS" && (
          <div
            className={`flex flex-row gap-2 items-center p-2 text-white rounded bg-[${config.bgColor}] justify-center cursor-default max-h-[38px]`}
            style={{ backgroundColor: config.bgColor }}
          >
            <img src={config.imgSrc} className="h-[26px]" alt="contract" />
            {type}
          </div>
        )}

        <div
          className={`flex flex-row gap-2 items-center p-2 text-white rounded bg-[${"#000063"}] justify-center cursor-default max-h-[38px]`}
          style={{ backgroundColor: "#000063" }}
        >
          <img
            src={siteConfig.medias.contract.EXPERTIS.path}
            className="h-[26px]"
            alt="contract"
          />
          EXPERTIS
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={`flex flex-row gap-2 items-center p-2 text-white rounded bg-[${"#000063"}] justify-center cursor-default max-h-[38px]`}
        style={{ backgroundColor: "#000063" }}
      >
        <img
          src={siteConfig.medias.contract.EXPERTIS.path}
          className="h-[26px]"
          alt="contract"
        />
        EXPERTIS
      </div>
    );
  }
};

export default ContractLabel;
